const getDataServiceName = "/TimesheetSiteServiceSecurity";
const personnelTimesheet = "/PersonnelTimesheet";

export function getDataService (http) {
    return {
        getPersonnelType: (type) => {
            let parameters = {
                Type: type
            }
            return http.post(getDataServiceName + "/GetAllPersonnelTypeCategory", parameters)
        },
        getSecurityPersonnelAsync: () => {
            return http.get(personnelTimesheet + "/GetSecurityPersonnelAsync")
        },
        getPersonnelTimesheets: (personnelCode, fromDate, toDate) => {
            var param = {
                "PersonnelCode": personnelCode,
                "FromDate": fromDate,
                "ToDate": toDate
            }
            return http.post(getDataServiceName + "/GetPersonnelTimesheets", param);
        },
        getALlSitePersonnelTimesheets: (fromDate, toDate) => {
            var param = {
                "FromDate": fromDate,
                "ToDate": toDate
            }
            return http.post(getDataServiceName + "/GetALlPersonnelTimesheets", param);
        }
    }
}